"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.User = void 0;
const auth_1 = require("@completeanatomy/auth");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const event_bus_1 = require("@completeanatomy/event-bus");
const http_1 = require("@completeanatomy/http");
const licenses_1 = require("@completeanatomy/licenses");
const storage_1 = require("@completeanatomy/storage");
const store_1 = require("@completeanatomy/store");
const jwt_decode_1 = __importDefault(require("jwt-decode"));
const lodash_isequal_1 = __importDefault(require("lodash.isequal"));
const redux_watch_1 = __importDefault(require("redux-watch"));
require("reflect-metadata");
const typedi_1 = require("typedi");
let User = class User {
    constructor(http, bridge, auth, store, storage, eventBus) {
        this.http = http;
        this.bridge = bridge;
        this.auth = auth;
        this.store = store;
        this.storage = storage;
        this.eventBus = eventBus;
        /**
         * Current user object identifier in the AppState
         * @private
         */
        this.currentUserIdentifier = 'currentUser';
        /**
         * Native storage key
         * @private
         */
        this.storageKey = 'currentUser';
        this.bridge.emit(bridge_schema_1.bridgeObjectAdded, {
            identifier: this.currentUserIdentifier,
            object: {},
        });
        // this.eventBus.on(AuthEvent.Authenticated, async () => {
        //   const newUserSurveyData =
        //     await this.getNewUserSurveyDataFromNativeCache();
        //   /**
        //    * Send cached new user survey data to the server on authentication
        //    * Remove cached data if request was successful
        //    */
        //   if (newUserSurveyData) {
        //     const response = await this.saveNewUserSurveyToBackend(
        //       newUserSurveyData
        //     );
        //     if (response.ok) {
        //       await this.fetchData(); // fetch user data to update user kind
        //       await this.setNewUserSurveyWasUploadedToBackend(true);
        //       await this.removeNewUserSurveyFromNativeCache();
        //     }
        //   }
        // });
        this.eventBus.on(event_bus_1.AuthEvent.Authenticated, () => __awaiter(this, void 0, void 0, function* () {
            yield this.fetchData();
        }));
        this.eventBus.on(event_bus_1.AuthEvent.NeedUpdateUserData, () => __awaiter(this, void 0, void 0, function* () {
            yield this.fetchData();
        }));
        this.eventBus.on(event_bus_1.AuthEvent.NeedClearUserData, () => {
            this.clear();
        });
        const identityTokenFieldWatcher = (0, redux_watch_1.default)(this.store.getState, 'auth.identityToken', lodash_isequal_1.default);
        this.store.subscribe(identityTokenFieldWatcher(() => {
            const dataFromIdentityToken = this.parsedIdentityToken();
            this.bridge.emit(bridge_schema_1.bridgeObjectChanged, {
                identifier: this.currentUserIdentifier,
                keyPath: '',
                changes: dataFromIdentityToken,
            });
        }));
    }
    /**
     * Method returns bio of current user by access token
     */
    bio() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.http.get({
                path: 'users/info/',
            });
            return response.json();
        });
    }
    /**
     * Update user biography on the server
     *
     * @param bio - new biography
     */
    updateBio(bio) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.http.patch({
                path: 'users/info/',
                data: {
                    biography: bio,
                },
                version: 13,
            });
            return response.json();
        });
    }
    /**
     * Update a user institution on the server
     *
     * @param institution - new institution
     */
    updateInstitution(institution) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.http.patch({
                path: 'users/info/',
                data: {
                    institution,
                },
                version: 13,
            });
            return response.json();
        });
    }
    /**
     * Method returns all interests from the server
     */
    interests() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.http.get({
                path: 'interests/',
            });
            return response.json();
        });
    }
    /**
     * This method will add a new interest
     *
     * @param interest - new interest
     */
    addInterest(interest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.http.post({
                path: 'interests/',
                data: {
                    name: interest,
                },
            });
            return response.json();
        });
    }
    /**
     * Update user interests
     *
     * @param interests - array of interests
     */
    updateInterests(interests) {
        return __awaiter(this, void 0, void 0, function* () {
            const interestsIds = interests.map(interest => interest.identifier);
            const response = yield this.http.patch({
                path: 'users/info/',
                data: {
                    interests: interestsIds,
                },
                version: 13,
            });
            return response.json();
        });
    }
    /**
     * Method fetch user profile data from API
     */
    fetchData() {
        return __awaiter(this, void 0, void 0, function* () {
            // const cachedData = await this.getFromNativeCache();
            //
            // if (cachedData) {
            //   this.bridge.emit(bridgeObjectChanged, {
            //     identifier: this.currentUserIdentifier,
            //     keyPath: '',
            //     changes: cachedData,
            //   });
            // }
            try {
                const interests = yield this.interests();
                const response = yield this.http.get({
                    path: 'users/info/',
                    version: 13,
                });
                if (!response.ok) {
                    throw new Error('Error fetching user info');
                }
                const user = (yield response.json());
                const { deviceInformation } = this.store.getState();
                const language = (deviceInformation === null || deviceInformation === void 0 ? void 0 : deviceInformation.language) || 'en';
                const bridgeObject = {
                    avatar: user.image_url,
                    biography: user.biography,
                    email: user === null || user === void 0 ? void 0 : user.email,
                    hasActiveUpgradeOrSubscription: false,
                    identifier: user.id,
                    institution: user.institution,
                    kind: user.kind,
                    name: user === null || user === void 0 ? void 0 : user.username,
                    specialties: user.interests.map(identifier => {
                        const speciality = interests.find(({ id }) => id === identifier);
                        return {
                            identifier: speciality.id,
                            name: speciality.translated[language] || speciality.name,
                        };
                    }),
                };
                if (user.organization) {
                    bridgeObject.organization = {
                        name: user.organization,
                        image: user.organization_image_url,
                    };
                }
                this.bridge.emit(bridge_schema_1.bridgeObjectChanged, {
                    identifier: this.currentUserIdentifier,
                    keyPath: '',
                    changes: bridgeObject,
                });
                this.updateAppState(user.subscriptions);
                //await this.saveToNativeCache(bridgeObject); //this Native code not working in grasshoper
            }
            catch (_) {
                console.error('[User] Error fetching user info');
            }
        });
    }
    /**
     * Clears profile data from AppState
     */
    clear() {
        this.bridge.emit(bridge_schema_1.bridgeObjectChanged, {
            identifier: this.currentUserIdentifier,
            keyPath: '',
            changes: null,
        });
        this.storage.delete(this.storageKey);
    }
    searchUsers(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.http.get({ path: `users/?search=${query}` });
            return response.json();
        });
    }
    /**
     * Returns parsed payload from identity token
     */
    parsedIdentityToken() {
        const token = this.auth.identityToken;
        if (token === undefined) {
            throw new Error('Identity token is undefined');
        }
        return (0, jwt_decode_1.default)(token);
    }
    // private async saveToNativeCache(userInfo: UserType) {
    //   await this.storage.put(this.storageKey, userInfo);
    // }
    // private getFromNativeCache(): Promise<UserType | undefined> {
    //   return this.storage.get(this.storageKey) as Promise<UserType | undefined>;
    // }
    /**
     * Puts licenses to the AppState
     *
     * @private
     */
    updateAppState(subscriptions) {
        const licenses = subscriptions.map(subscription => ({
            expireAt: new Date(subscription.expire),
            isActive: subscription.active,
            isB2B: subscription.bundle.includes('B2B'),
            productId: subscription.bundle,
            type: (0, licenses_1.getLicenseTypeByBundleName)(subscription.bundle),
        }));
        this.bridge.emit(bridge_schema_1.bridgeObjectChanged, {
            identifier: 'userLicenses',
            keyPath: '',
            changes: licenses,
        });
    }
};
exports.User = User;
/**
 * Name of exported module property
 */
User.exportName = 'user';
exports.User = User = __decorate([
    (0, typedi_1.Service)(),
    __param(3, (0, typedi_1.Inject)(store_1.StoreToken)),
    __metadata("design:paramtypes", [http_1.HTTP,
        bridge_schema_1.BridgeInterface,
        auth_1.Auth, Object, storage_1.Storage,
        event_bus_1.EventBus])
], User);
